import React from "react";
import "./Projects.css";
import bookmyshow from "../Material/bookmyshow.jpg";
import ludoGame from "../Material/ludo-screenshot.png";
import cagefireGame from "../Material/cagefire-screenshot.png";
import ImgReact from "../Material/icons8-react-160.png";
import ImgRedux from "../Material/icons8-redux-500.png";
import ImgMongodb from "../Material/icons8-mongodb-144.png";
import ImgCss from "../Material/icons8-css3-100.png";
import ImgHtml from "../Material/icons8-html-100.png";
import ImgGit from "../Material/icons8-github-120.png";
import Couch from "../Material/Couch.png";
import ImgJS from "../Material/icons8-javascript-100.png";
import ImgCode from "../Material/icons8-code-100.png";
import ImgPlayStore from "../Material/icons8-playstore-100.png";
import Sudoku from "../Material/sudoku.png";
import Eye from "../Material/eye.png";
import C from "../Material/C.png";
import unity from "../Material/unity.png";
import adove from "../Material/adove.png";
import wordtrick from "../Material/wordtrick.jpg";
import AOS from "aos";
import "aos/dist/aos.css";

const Projects = () => {
  AOS.init();
  return (
    <div className="Projects_Container">
      <h1>Projects</h1>
      <div
        data-aos="flip-right"
        data-aos-offset="10"
        data-aos-delay="40"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
        data-aos-anchor-placement="top-center"
        className="Projects_Container_In"
      >
        <div>
          <div>
            <img
              className="Projects_Container_In__main_img"
              src={ludoGame}
              alt="Ludo Game"
              style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: '20px', borderRadius: '15px' }}
            />
          </div>
          <div>
            <h3>Ludo Game - MPL</h3>
            <div className="project-badge">🎮 Published on Play Store</div>
            <p>
              A professional Ludo game developed using HTML5 Canvas and vanilla JavaScript. 
              Published on the Play Store as a free-to-play title to drive user acquisition 
              and convert players into real-money gaming (RMG) users for MPL. Features 
              smooth animations, multiplayer gameplay, and optimized performance for mobile devices.
            </p>
            <h3>Tech stack used :</h3>
            <div className="Projects_Container_In__stack_img">
              <img src={ImgHtml} alt="HTML5" />
              <img src={ImgCss} alt="CSS" />
              <img src={ImgJS} alt="JavaScript" />
              <img src={ImgCode} alt="Canvas API" />
            </div>
          </div>
          <div style={{ borderTop: "1px solid black" }}>
            <a href="https://play.google.com/store/apps/details?id=com.mpl.ludo" target="_blank" rel="noopener noreferrer">
              <img
                style={{ width: 35, cursor: "pointer", margin: 10 }}
                src={ImgPlayStore}
                alt="Play Store"
                title="Download on Play Store"
              />
            </a>
          </div>
        </div>
        <div>
          <div>
            <img
              className="Projects_Container_In__main_img"
              src={bookmyshow}
              alt="bookmyshow"
            />
          </div>
          <div>
            <h3>BookMyShow Clone</h3>
            <p>
              BookMyShow website is basically for entertainment purpose, In this
              app, a user can book movie tickets by choosing the different
              theatres and timings accordingly. The user also can see some
              events happening around them and can attend the events.
            </p>
            <h3>Teck stack used :</h3>
            <div className="Projects_Container_In__stack_img">
              <img src={ImgReact} alt="react" />
              <img src={ImgRedux} alt="react" />
              <img src={ImgMongodb} alt="mongodb" />
              <img src={ImgCss} alt="Css" />
            </div>
          </div>
          <div style={{ borderTop: "1px solid black" }}>
            <a href="https://github.com/arshadalitalwar/bookmyshow">
              <img
                style={{ width: 35, cursor: "pointer", margin: 10 }}
                src={ImgGit}
                alt="Git"
              />
            </a>
            <a href="https://arshadalitalwar.medium.com/bookmyshow-clone-in-4-days-2ff0b925fa60">
              <img
                style={{ width: 35, cursor: "pointer", margin: 10 }}
                src={Eye}
                alt="eye"
              />
            </a>
          </div>
        </div>
        <div>
          <div>
            <img
              className="Projects_Container_In__main_img"
              src={Couch}
              alt="Couch"
              style={{ height: 200 }}
            />
          </div>
          <div>
            <h3>CouchSurfing (clone)</h3>
            <p>
              CouchSurfing is a global hospitality exchange service accessible
              via a website and mobile app. Members can request lodging publicly
              or directly from other members, "hang out" with other members, or
              join/create events.
            </p>
            <h3>Teck stack used :</h3>
            <div className="Projects_Container_In__stack_img">
              <img src={ImgReact} alt="react" />
              <img src={ImgRedux} alt="react" />
              <img src={ImgCss} alt="Css" />
            </div>
          </div>
          <div style={{ borderTop: "1px solid black" }}>
            <a href="https://github.com/iharshgaur/Couchsurfing-Bravo">
              <img
                style={{ width: 35, cursor: "pointer", margin: 10 }}
                src={ImgGit}
                alt="Git"
              />
            </a>
            <a href="https://arshadalitalwar.medium.com/our-first-project-in-react-55d13fdd6982">
              <img
                style={{ width: 35, cursor: "pointer", margin: 10 }}
                src={Eye}
                alt="eye"
              />
            </a>
          </div>
        </div>
        <div>
          <div>
            <img
              className="Projects_Container_In__main_img"
              src={Sudoku}
              alt="Sudoku"
            />
          </div>
          <div style={{ marginTop: 35 }}>
            <h3>Sudoku Solver</h3>
            <p>
              Enter the numbers of the puzzle you want to solve in the grid. You
              can solve the puzzle completely, Checks if the puzzle is valid,
              can be solved and has a single solution
            </p>
            <h3>Teck stack used :</h3>
            <div className="Projects_Container_In__stack_img">
              <img src={ImgReact} alt="react" />
              <img src={ImgJS} alt="JS" />
              <img src={ImgCss} alt="Css" />
            </div>
          </div>
          <div style={{ borderTop: "1px solid black" }}>
            <a href="https://github.com/arshadalitalwar/sudoku-solver">
              <img
                style={{ width: 35, cursor: "pointer", margin: 10 }}
                src={ImgGit}
                alt="Git"
              />
            </a>
            <a href="https://sudoku-solver-374467-by-arshadali.netlify.app/">
              <img
                style={{ width: 35, cursor: "pointer", margin: 10 }}
                src={Eye}
                alt="eye"
              />
            </a>
          </div>
        </div>
        <div>
          <div>
            <img
              className="Projects_Container_In__main_img"
              src={wordtrick}
              alt="wordtrick"
            />
          </div>
          <div style={{ marginTop: 35 }}>
            <h3>Word Trick</h3>
            <p>
              Word Trick a word search video game only for android platform .
              Where user can ﬁnd antonyms and synonyms ,and also play a quiz.{" "}
            </p>
            <h3>Teck stack used :</h3>
            <div className="Projects_Container_In__stack_img">
              <img src={unity} alt="unity" />
              <img src={C} alt="C" />
              <img src={adove} alt="adove" />
            </div>
          </div>
          <div style={{ borderTop: "1px solid black" }}>
            <a href="https://play.google.com/store/apps/details?id=com.Talwaraaa.wordtrick" target="_blank" rel="noopener noreferrer">
              <img
                style={{ width: 35, cursor: "pointer", margin: 10 }}
                src={Eye}
                alt="eye"
              />
            </a>
          </div>
        </div>
        <div>
          <div>
            <img
              className="Projects_Container_In__main_img"
              src={cagefireGame}
              alt="CageFire"
              style={{ objectFit: 'cover' }}
            />
          </div>
          <div>
            <h3>CageFire</h3>
            <div className="project-badge">🎮 Published on Play Store</div>
            <p>
              An action-packed Android game where players strategically bring enemies into cages, 
              fire to eliminate them, and collect bombs. Save your bombs wisely - they're the only 
              weapon powerful enough to defeat the dragon boss! Fast-paced gameplay with strategic elements.
            </p>
            <h3>Teck stack used :</h3>
            <div className="Projects_Container_In__stack_img">
              <img src={unity} alt="Unity3D" />
              <img src={C} alt="C#" />
              <img src={adove} alt="Adobe" />
            </div>
          </div>
          <div style={{ borderTop: "1px solid black" }}>
            <a href="https://www.youtube.com/watch?v=ESHEPipcKic" target="_blank" rel="noopener noreferrer">
              <img
                style={{ width: 35, cursor: "pointer", margin: 10 }}
                src={Eye}
                alt="Watch Video"
                title="Watch Gameplay Video"
              />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.talwaraaa.cagefire&hl=en_IN" target="_blank" rel="noopener noreferrer">
              <img
                style={{ width: 35, cursor: "pointer", margin: 10 }}
                src={ImgPlayStore}
                alt="Play Store"
                title="Download on Play Store"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
